<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs"
           :key="isSmallerScreen">
    <vs-tab v-if="$canAny(['view-user','create-user'])"  icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? 'User' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <staff-users/>
      </div>
    </vs-tab>
    <vs-tab v-if="$canAny(['view-user-role','create-user-role'])" icon-pack="feather" icon="icon-shield" :label="!isSmallerScreen ? 'User Roles' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <staff-group-profile/>
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import StaffUsers from './tabs/StaffUsers.vue'
import StaffGroupProfile from './tabs/StaffGroupProfile.vue'
import TreeTest from './tabs/TreeTest.vue'
// import PendingUsersList from './PendingUsersList.vue'
import Vue from 'vue';


export default {
  components: {
    StaffUsers,
    StaffGroupProfile,
    TreeTest
    // PendingUsersList,
  },
  data () {
    return {
      isActiveManageStaff: this.$can('view-user'),
    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }
</style>
